import api from '../api/api'

export default {
    loadTranslations: async (context, idlang) => {    
        context.commit('LOADING')    
        let data  =  await api.getTranslations(idlang)
        context.commit('SET_TRANSLATIONS', data)
        context.commit('LOADED')
    },
}